module.exports = __webpack_public_path__ + "img/DSC_2882-xl.05c7ab80.png";